import contentfulGql from 'js/lib/contentfulGql';

export const entWebsiteNativeDataSourceFragment = contentfulGql`#graphql
  fragment EntWebsiteNativeDataSource on EntWebsiteNativeDataSource {
    slug
    type
  }
`;
